import { Broker, BROKER_CONNECTION_STATE } from "~shapes/portfolio"

export const authorizedBrokers = (brokers: Broker[]) => {
  return brokers.filter(
    conn => conn.state === BROKER_CONNECTION_STATE.AUTHORIZED
  )
}
